module.exports = __webpack_public_path__ + "img/wallet.b1f88073.png";